import {useState} from 'react';
import {useMutation, useQueryClient} from 'react-query';
import {STORAGE_OBJECTS_QUERY_KEY} from '../init/constants';
import {APIClient} from '../backend/ApiClient';
import {CreateFolderDTO} from '../models/dto/CreateFolderDTO';

export const useCreateFolder = () => {
    const [createFolderModeActive, setCreateFolderModeActive] = useState<boolean>(false);
    const queryClient = useQueryClient();
    const apiClient = APIClient();

    const createFolderApiCall = (createFolderDTO: CreateFolderDTO) => {
        return apiClient.createFolder(createFolderDTO.item);
    };

    const {mutateAsync: createFolderMutation, isLoading} = useMutation(createFolderApiCall, {
        onSuccess: () => {
            queryClient.invalidateQueries(STORAGE_OBJECTS_QUERY_KEY);
        }
    });

    const createFolder = (createFolderDTO: CreateFolderDTO, addMore: boolean) => {
        return createFolderMutation(createFolderDTO, {
            onSuccess: () => {
                setCreateFolderModeActive(false);
                if (addMore) {
                    setCreateFolderModeActive(true);
                }
            }
        });
    };

    return {createFolderModeActive, setCreateFolderModeActive, createFolder, isLoading};
};
